import { RecordCreateScreen } from "@/lib/Components/Screens/RecordScreen/RecordCreateScreen";
import { RecordCreateCard } from "@/lib/Components/SideBarList/Cards/RecordCreateCard";
import { CityForm } from "@/app/Cities/Cities/Forms/CityForm";
import { CreateCityInput } from "@/gql/graphql";
import { useNavigate } from "@tanstack/react-router";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createCityMutation } from "@/app/Cities/Cities/GraphQL/cityMutations";

export function CityCreateScreen() {
  const { mutateAsync } = useGqlMutation(createCityMutation);
  const navigate = useNavigate();

  return (
    <RecordCreateScreen>
      <RecordCreateCard<CreateCityInput>
        title="Create city"
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: values,
          });

          await navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/cities/$id",
            params: (prev) => ({
              ...prev,
              id: res.createCity.id,
            }),
          });
        }}
        initialValues={{
          name: "",
          slug: "",
          region: null!,
          state: null!,
        }}
      >
        <CityForm />
      </RecordCreateCard>
    </RecordCreateScreen>
  );
}
